import { Route, Routes } from 'react-router-dom'
import SoFoodPageWrapper from '../khipu/features/sooFood/pages/SoFoodPageWrapper'

const SoFoodRoutes = () => {
  return (
    <Routes>
      <Route index element={<SoFoodPageWrapper />} />
    </Routes>
  )
}

export { SoFoodRoutes }
